import React from "react";
import { forgotPassword } from "frontend/src/api/auth";
import { isValidEmail } from "frontend/src/lib/is-valid-email";
import { resetPassword } from "frontend/src/api/auth/reset-password";
import i18next from "i18next";
import { locales } from "../../domain/localization/i18n";
export var useForgotPassword = function () {
    var _a = React.useState(""), email = _a[0], setEmail = _a[1];
    var _b = React.useState(false), pending = _b[0], setPending = _b[1];
    var _c = React.useState({}), errors = _c[0], setErrors = _c[1];
    var _d = React.useState(false), success = _d[0], setSuccess = _d[1];
    var validate = function () {
        var _a, _b;
        var isValid = true;
        var errors = { email: [] };
        if (email.length === 0) {
            (_a = errors.email) === null || _a === void 0 ? void 0 : _a.push(i18next.t("errors.emptyField", { ns: locales.namespaces.shared }));
            isValid = false;
        }
        if (!isValidEmail(email)) {
            (_b = errors.email) === null || _b === void 0 ? void 0 : _b.push(i18next.t("errors.invalidEmail", { ns: locales.namespaces.shared }));
            isValid = false;
        }
        if (!isValid) {
            setErrors(errors);
        }
        return isValid;
    };
    var submit = function () {
        setErrors({});
        if (!validate()) {
            return;
        }
        setPending(true);
        forgotPassword(email)
            .then(function (response) {
            if (response.type === "failure" && response.errors.email) {
                setErrors({
                    email: response.errors.email,
                });
            }
            else {
                setSuccess(true);
            }
        })
            .catch(function () { return setErrors({ unknown: true }); })
            .finally(function () { return setPending(false); });
    };
    return {
        submit: submit,
        email: { value: email, set: setEmail },
        errors: errors,
        pending: pending,
        success: success,
    };
};
export var useResetPassword = function () {
    var _a = React.useState(""), email = _a[0], setEmail = _a[1];
    var _b = React.useState(""), password = _b[0], setPassword = _b[1];
    var _c = React.useState(false), pending = _c[0], setPending = _c[1];
    var _d = React.useState({}), errors = _d[0], setErrors = _d[1];
    var _e = React.useState(false), success = _e[0], setSuccess = _e[1];
    var validate = function () {
        var _a, _b, _c;
        var isValid = true;
        var errors = { email: [], password: [] };
        if (email.length === 0) {
            (_a = errors.email) === null || _a === void 0 ? void 0 : _a.push(i18next.t("errors.emptyField", { ns: locales.namespaces.shared }));
            isValid = false;
        }
        if (!isValidEmail(email)) {
            (_b = errors.email) === null || _b === void 0 ? void 0 : _b.push(i18next.t("errors.invalidEmail", { ns: locales.namespaces.shared }));
            isValid = false;
        }
        if (password.length === 0) {
            (_c = errors.password) === null || _c === void 0 ? void 0 : _c.push(i18next.t("errors.emptyField", { ns: locales.namespaces.shared }));
        }
        if (!isValid) {
            setErrors(errors);
        }
        return isValid;
    };
    var reset = function (token) {
        setErrors({});
        setSuccess(false);
        if (!validate()) {
            return;
        }
        setPending(true);
        resetPassword({ password: password, token: token, email: email })
            .then(function (response) {
            if (response.type === "failure") {
                setErrors(response.errors);
            }
            else {
                setSuccess(true);
            }
        })
            .catch(function () { return setErrors({ unknown: true }); })
            .finally(function () { return setPending(false); });
    };
    return {
        reset: reset,
        password: { value: password, set: setPassword },
        email: { value: email, set: setEmail },
        errors: errors,
        pending: pending,
        success: success,
    };
};
